import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Tasks from './Task';
import Projects from './Project';
import DrawingBoard from './DrawingBoard';
import blackTexture from '../assets/black.webp'; // dark mode background
import lightTexture from '../assets/white.jpg'; // light mode background (place in src/assets)

function MainPage({ user, setUser }) {
  const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(
    JSON.parse(localStorage.getItem('darkMode')) || false
  );

  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(darkMode));
  }, [darkMode]);

  const handleLogout = () => {
    localStorage.removeItem('currentUser');
    setUser(null);
    navigate('/');
  };

  const toggleTheme = () => {
    setDarkMode(!darkMode);
  };

  return (
    <div
      style={{
        backgroundImage: darkMode
          ? `url(${blackTexture})`
          : `url(${lightTexture})`,
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        backgroundPosition: 'center',
        minHeight: '100vh',
        color: darkMode ? 'white' : 'black',
        paddingTop: '20px',
        transition: 'all 0.3s ease-in-out'
      }}
    >
      <Container>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h1>Welcome, {user.email}</h1>
          <div>
            <Button
              variant={darkMode ? 'light' : 'dark'}
              className="me-2"
              onClick={toggleTheme}
            >
              Switch to {darkMode ? 'Light' : 'Dark'} Mode
            </Button>
            <Button variant="danger" onClick={handleLogout}>
              Sign Out
            </Button>
          </div>
        </div>

        <Row>
          <Col md={6}>
            <Tasks user={user} setUser={setUser} />
            <Projects user={user} setUser={setUser} />
          </Col>
          <Col md={6}>
            <DrawingBoard />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default MainPage;
